var LocationGroupLegacyModule = /** @class */ (function () {
    function LocationGroupLegacyModule() {
    }
    return LocationGroupLegacyModule;
}());
export { LocationGroupLegacyModule };
